import { render, staticRenderFns } from "./PlayerResources.vue?vue&type=template&id=350b19a6"
import script from "./PlayerResources.vue?vue&type=script&lang=ts"
export * from "./PlayerResources.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports